import { useEffect, useState } from 'react';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { accountQuery, verifyEmail } from '@/api';
import { RegisterThankYouModal } from '@/ui/auth';

export const Route = createFileRoute('/verifyemail/$token')({
  component: VerifyEmailPage,
});

function VerifyEmailPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { token } = Route.useParams();
  const { data: account } = useQuery(accountQuery());
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [done, setDone] = useState(false);

  const chatEnabled = account?.Chat === true;

  useEffect(() => {
    let cancelled = false;
    const run = async () => {
      setLoading(true);
      setError(null);
      try {
        const result = await verifyEmail({ Value: token });
        if (cancelled) return;
        if (result.Success === false) {
          setError(
            t(result.Error || 'EmailVerificationFailed', {
              defaultValue: 'Email verification failed',
            }),
          );
        }
        setDone(true);
      } catch (err) {
        if (cancelled) return;
        const message =
          err instanceof Error && err.message ? err.message : 'EmailVerificationFailed';
        setError(t(message, { defaultValue: message }));
        setDone(true);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    void run();
    return () => {
      cancelled = true;
    };
  }, [token, t]);

  const leave = () => {
    void navigate({ href: '/' });
  };

  return (
    <RegisterThankYouModal
      open={done || loading}
      dismissible
      onClose={leave}
      loading={loading}
      error={error}
      chatEnabled={chatEnabled}
      onLogin={() => {
        void navigate({ to: '/login' });
      }}
    />
  );
}
